module.exports = __webpack_public_path__ + "static/media/user4.be495d6e.jpg";